import crossPromotionalSectionImg from '../../../../../assets/images/crossPromotional.webp';

export const CROSS_PROMOTIONAL_CONTENT = {
  preHeading: 'Step into a new chapter with us',
  title: 'Considering a new career\nhelping others?',
  sectionImg: crossPromotionalSectionImg,
  description:
    'If you feel called to meaningful, heart-centered work,\nInterpersonal Hypnotherapy may be your path',
  bottomCaption:
    'Explore training with IIH and take your next step\ntoward a conscious, service-driven career',
  contentHeader: 'With the Institute of Interpersonal Hypnotherapy (IIH), you can:',
  contentList: [
    'Train for a rewarding career helping people grow, change, and live more peaceful lives',
    'Build a flexible practice and shape your own schedule',
    'Begin with no prior degree required',
    'Complete a comprehensive, 500-hour state-licensed training program',
    'Become eligible to apply to join the Nirva practitioner team and be part of something truly special',
  ],
  buttonText: 'Start Your Interpersonal\nHypnotherapy Journey',
};
